<ng-container *ngIf="(home$ | async) as home">
  <view-edit-user-timezone (home)="home"></view-edit-user-timezone>
</ng-container>
